import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mtn-simple-panel',
  templateUrl: './simple-panel.component.html',
  styleUrls: ['./simple-panel.component.scss']
})
export class SimplePanelComponent  {

  @Input()
  color: string;

  constructor() {
  }


}
